module.exports = __webpack_public_path__ + "img/advantage3@2x.8dd05735.png";